import { TextField, TextFieldProps } from "@mui/material";
import { Control, FieldValues, Path } from "react-hook-form";

import { SuggestedField } from "./SuggestedField";

type SuggestedTextFieldProps<T extends FieldValues> = {
  name: Path<T>;
  control: Control<T>;
  needsReview: boolean;
} & Omit<TextFieldProps, "name" | "value" | "onChange" | "onBlur">;

/**
 * Convenience wrapper around SuggestedField for plain TextFields.
 * For custom inputs (checkboxes, numeric fields), use SuggestedField directly.
 */
export function SuggestedTextField<T extends FieldValues>({
  name,
  control,
  needsReview,
  ...textFieldProps
}: SuggestedTextFieldProps<T>) {
  return (
    <SuggestedField name={name} control={control} needsReview={needsReview}>
      {({ field, isSuggested, sparkleAdornment }) => (
        <TextField
          {...field}
          {...textFieldProps}
          slotProps={{
            ...textFieldProps.slotProps,
            input: {
              ...textFieldProps.slotProps?.input,
              startAdornment: isSuggested ? sparkleAdornment : undefined,
            },
          }}
        />
      )}
    </SuggestedField>
  );
}
